<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" :lg="$store.state.CARGO.id == 1 ? 3 : 5">
          <span>PAGOS: PROGRAMAS</span>
        </v-col>

        <v-col v-if="$store.state.CARGO.id == 1" cols="12" md="6" lg="2">
          <div class="d-flex">
            <v-switch style="margin-top: -4px" v-model="mostrarTodasSedes" hide-details label="Ver todos"></v-switch>
          </div>
        </v-col>

        <v-col cols="12" md="6" lg="5">
          <v-pagination
            class="custom-pagination"
            v-model="pagina"
            :length="metadatos?.totalPaginas || 0"
            :total-visible="10"
            @input="listar"></v-pagination>
        </v-col>

        <v-col cols="12" md="6" lg="2">
          <v-select
            :items="[10, 25, 50, 75, 100, 500]"
            label="Items por página"
            v-model="itemsPorPagina"
            outlined
            dense
            hide-details
            :disabled="items.length == 0"
            @change="cambiarPagina" />
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col v-if="permisosAcademicosNacional" cols="12" md="2" xl="2">
        <v-select
          v-model="sedeEspecificaId"
          :items="sedes"
          label="Sede"
          outlined
          dense
          hide-details
          item-text="nombre"
          item-value="id"
          clearable
          @change="listarRestableciendoPagina"></v-select>
      </v-col>

      <v-col cols="12" md="2" xl="2">
        <v-select
          v-model="gestion"
          :items="gestiones"
          label="Gestión"
          outlined
          dense
          hide-details
          item-text="gestion"
          item-value="gestion"
          clearable
          @change="listarRestableciendoPagina"></v-select>
      </v-col>

      <v-col cols="12" :md="permisosAcademicosNacional ? 6 : 8" :xl="permisosAcademicosNacional ? 6 : 8">
        <v-btn
          v-if="permisosAcademicosSedeDBS"
          small
          class="mx-1"
          :disabled="item == null"
          title="Solicitud de Inscripciones"
          @click="$refs.modalSolicitudesInscripcionesRef.abrir(accionesCrud.EDITAR, item)">
          <v-icon>mdi-file-document-multiple-outline</v-icon>

          Solicitud Inscripciones
        </v-btn>

        <v-btn
          v-if="permisosAcademicosSede || permisosAcademicosNacional || permisosAcademicosSedeSoloLectura"
          small
          class="mx-1"
          :disabled="item == null || !item?.programaUniversidadId"
          title="Ver Inscripciones al Programa Universidad"
          @click="abrirModalVerInscripcionesProgramaUniversidad(item)">
          <v-icon>mdi-file-document-multiple-outline</v-icon>

          Inscripciones Programa Univ.
        </v-btn>

        <v-btn
          v-if="permisosAcademicosNacional"
          small
          class="mx-1"
          :disabled="item == null || !!item?.programaUniversidadId"
          title="Establecer Programa Universidad"
          @click="$refs.modalFormularioEstablecerProgramaUniversidadRef.abrir(item)">
          <v-icon>mdi-text-box</v-icon>

          Est. Programa Universidad
        </v-btn>

        <v-btn
          v-if="permisosAcademicosSede"
          small
          class="mx-1"
          :disabled="item == null || !item?.programaUniversidadId || item?.programaReportado != null"
          title="Reportar Programa"
          @click="handleAbrirModalReportarPrograma(item)">
          <v-icon>mdi-alert-circle-outline</v-icon>

          Reportar Programa
        </v-btn>

        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="2" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoProgramasPaginados ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalSolicitudesInscripciones ref="modalSolicitudesInscripcionesRef" :nombreRecurso="nombreItem1" />

    <ModalFormularioEstablecerProgramaUniversidad
      ref="modalFormularioEstablecerProgramaUniversidadRef"
      @actualizarListado="listar" />

    <ModalVerInscripcionesProgramaUniversidad
      ref="modalVerInscripcionesProgramaUniversidadRef"
      :nombreRecurso="nombreItem2" />

    <ModalReportarPrograma ref="modalReportarProgramaRef" @programa-reportado="listar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoProgramasPaginados from '../components/ListadoProgramasPaginados.vue';
import ProgramaService from '../services/programa.service';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ModalSolicitudesInscripciones from '../components/ModalSolicitudesInscripciones.vue';
import GestionService from '../services/gestion.service';
import ModalFormularioEstablecerProgramaUniversidad from '../components/ModalFormularioEstablecerProgramaUniversidad.vue';
import { mapGetters } from 'vuex';
import SedeService from '../services/sede.service';
import ModalVerInscripcionesProgramaUniversidad from '../components/ModalVerInscripcionesProgramaUniversidad.vue';
import ModalReportarPrograma from '../components/ModalReportarPrograma.vue';
import { ESTADOS_PROGRAMAS_UNIVERSIDADES } from '../utils/constantes';

export default {
  name: 'ProgramasLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoProgramasPaginados,
    ModalSolicitudesInscripciones,
    ModalFormularioEstablecerProgramaUniversidad,
    ModalVerInscripcionesProgramaUniversidad,
    ModalReportarPrograma,
  },
  data() {
    return {
      nombreItem: 'Programa',
      gestiones: [],
      gestion: null,
      nombreItem1: 'Solicitud Inscripción',
      nombreItem2: 'Inscripciones Programa Universidad',
      sedes: [],
      sedeId: null,
      mostrarTodasSedes: false,
      sedeEspecificaId: null,
    };
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.sedeEspecificaId = null;
      this.obtenerSedes();

      if (!this.mostrarTodasSedes) {
        this.listarRestableciendoPagina();
      }
    },
    mostrarTodasSedes() {
      this.sedeEspecificaId = null;
      this.obtenerSedes();
      this.listarRestableciendoPagina();
    },
  },
  computed: {
    ...mapGetters({
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
      permisosAcademicosSede: 'pago/permisosAcademicosSede',
      permisosAcademicosSedeSoloLectura: 'pago/permisosAcademicosSedeSoloLectura',
      permisosAcademicosSedeDBS: 'pago/permisosAcademicosSedeDBS',
    }),
  },
  mounted() {
    this.obtenerGestiones();
    this.obtenerSedes();
    this.listar();
  },
  methods: {
    listar() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
        busqueda: this.busqueda,
        sedeEspecificaId: this.mostrarTodasSedes
          ? null
          : this.permisosAcademicosNacional
          ? this.sedeEspecificaId
          : this.$store.state.CARGO.sede.id,
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
        gestion: this.gestion,
      };

      this.obtenerDatosPaginadosConNotificacion(ProgramaService.findAll, 'items', 'metadatos', this.nombreItem, params);

      this.item = null;
    },
    obtenerGestiones() {
      this.obtenerDatosMixin(GestionService.findAll, 'gestiones');
    },
    obtenerSedes() {
      this.obtenerDatosMixin(SedeService.findAll, 'sedes', {
        sedeId: this.mostrarTodasSedes ? null : this.$store.state.CARGO.sede.id,
      });
    },
    abrirModalVerInscripcionesProgramaUniversidad(item) {
      if (!item || !item.programaUniversidadId) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Error',
          text: 'EL programa seleccionado no tiene un Programa Universidad asociado.',
        });

        return;
      }

      this.$refs.modalVerInscripcionesProgramaUniversidadRef.abrir(this.accionesCrud.EDITAR, item);
    },
    handleAbrirModalReportarPrograma() {
      if (this.item.programaUniversidad.estado !== ESTADOS_PROGRAMAS_UNIVERSIDADES.PENDIENTE) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Error',
          text: 'Solo se pueden reportar programas con el Programa Universidad que esté en estado PENDIENTE.',
        });

        return;
      }

      this.$refs.modalReportarProgramaRef.abrir(this.accionesCrud.VER, this.item);
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>